import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Chatbotlearning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.chatbotlearning_Id,
          sortable: true,
          cell: (row) => <span>{row.chatbotlearning_Id}</span>,
        },
        { name: "Conversation Id", selector: (row, i) => row.conversation_id, sortable: true, cell: (row) => <span>{row.conversation_id}</span>, }, { name: "User Message", selector: (row, i) => row.user_message, sortable: true, cell: (row) => <span>{row.user_message}</span>, }, { name: "Bot Response", selector: (row, i) => row.bot_response, sortable: true, cell: (row) => <span>{row.bot_response}</span>, }, { name: "User Feedback", selector: (row, i) => row.user_feedback, sortable: true, cell: (row) => <span>{row.user_feedback}</span>, }, { name: "Correct Response", selector: (row, i) => row.correct_response, sortable: true, cell: (row) => <span>{row.correct_response}</span>, }, { name: "Learning Source", selector: (row, i) => row.learning_source, sortable: true, cell: (row) => <span>{row.learning_source}</span>, }, { name: "Improvent Suggestion", selector: (row, i) => row.improvement_suggestion, sortable: true, cell: (row) => <span>{row.improvement_suggestion}</span>, }, { name: "Processed For Training", selector: (row, i) => row.processed_for_training, sortable: true, cell: (row) => <span>{row.processed_for_training}</span>, }, { name: "Claude Analysis", selector: (row, i) => row.claude_analysis, sortable: true, cell: (row) => <span>{row.claude_analysis}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.ChatbotlearningeditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      chatbotlearning_Id: "",
      conversations: [], conversation_id: '', user_message: '', bot_response: '', chatbotuserfeedback: [], user_feedback: '', correct_response: '', chatbotlearningsource: [], learning_source: '', improvement_suggestion: '', processed_for_training: '', claude_analysis: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'conversation_id', inputType: 'Select', displayName: 'Conversation Id', validationOptions: { isRequired: false } },
      { fieldName: 'user_message', inputType: 'Text', displayName: 'User Message', validationOptions: { isRequired: false } },
      { fieldName: 'bot_response', inputType: 'Text', displayName: 'Bot Response', validationOptions: { isRequired: false } },
      { fieldName: 'user_feedback', inputType: 'Select', displayName: 'User Feedback', validationOptions: { isRequired: false } },
      { fieldName: 'correct_response', inputType: 'Text', displayName: 'Correct Response', validationOptions: { isRequired: false } },
      { fieldName: 'learning_source', inputType: 'Select', displayName: 'Learning Source', validationOptions: { isRequired: false } },
      { fieldName: 'improvement_suggestion', inputType: 'Text', displayName: 'Improvent Suggestion', validationOptions: { isRequired: false } },
      { fieldName: 'processed_for_training', inputType: 'Number', displayName: 'Processed For Training', validationOptions: { isRequired: false } },
      { fieldName: 'claude_analysis', inputType: 'Text', displayName: 'Claude Analysis', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      conversations: [], conversation_id: '', user_message: '', bot_response: '', chatbotuserfeedback: [], user_feedback: '', correct_response: '', chatbotlearningsource: [], learning_source: '', improvement_suggestion: '', processed_for_training: '', claude_analysis: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      conversations: [], conversation_id: '', user_message: '', bot_response: '', chatbotuserfeedback: [], user_feedback: '', correct_response: '', chatbotlearningsource: [], learning_source: '', improvement_suggestion: '', processed_for_training: '', claude_analysis: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  ChatbotlearningeditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      chatbotlearning_Id: row.chatbotlearning_Id,
      conversations: [], conversation_id: row.conversation_id, user_message: row.user_message, bot_response: row.bot_response, chatbotuserfeedback: [], user_feedback: row.user_feedback, correct_response: row.correct_response, chatbotlearningsource: [], learning_source: row.learning_source, improvement_suggestion: row.improvement_suggestion, processed_for_training: row.processed_for_training, claude_analysis: row.claude_analysis,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  ChatbotlearningfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Chatbotlearning/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  ChatbotlearningsubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('conversation_id', this.state.conversation_id);
    formData.append('user_message', this.state.user_message);
    formData.append('bot_response', this.state.bot_response);
    formData.append('user_feedback', this.state.user_feedback);
    formData.append('correct_response', this.state.correct_response);
    formData.append('learning_source', this.state.learning_source);
    formData.append('improvement_suggestion', this.state.improvement_suggestion);
    formData.append('processed_for_training', this.state.processed_for_training);
    formData.append('claude_analysis', this.state.claude_analysis);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Chatbotlearning/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotlearningfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ conversations: [], conversation_id: '', user_message: '', bot_response: '', chatbotuserfeedback: [], user_feedback: '', correct_response: '', chatbotlearningsource: [], learning_source: '', improvement_suggestion: '', processed_for_training: '', claude_analysis: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  ChatbotlearningupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("chatbotlearning_Id", this.state.chatbotlearning_Id);
    formData.append('conversation_id', this.state.conversation_id);
    formData.append('user_message', this.state.user_message);
    formData.append('bot_response', this.state.bot_response);
    formData.append('user_feedback', this.state.user_feedback);
    formData.append('correct_response', this.state.correct_response);
    formData.append('learning_source', this.state.learning_source);
    formData.append('improvement_suggestion', this.state.improvement_suggestion);
    formData.append('processed_for_training', this.state.processed_for_training);
    formData.append('claude_analysis', this.state.claude_analysis);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Chatbotlearning/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotlearningfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.ChatbotlearningfetchHandler();
    this.conversationsfetchHandler();
    this.chatbotuserfeedbackfetchHandler();
    this.chatbotlearningsourcefetchHandler();

    //***componentDidMount
  }

  handleconversation_idChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ conversation_id: fieldValue });
  }; conversationsfetchHandler = () => {
    fetch(configData.api_url + "C_Conversations/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ conversations: data.list });
        }
      });
  }; handleuser_messageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ user_message: fieldValue });
  }; handlebot_responseChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ bot_response: fieldValue });
  }; handleuser_feedbackChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ user_feedback: fieldValue });
  }; chatbotuserfeedbackfetchHandler = () => {
    fetch(configData.api_url + "C_Chatbotuserfeedback/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ chatbotuserfeedback: data.list });
        }
      });
  }; handlecorrect_responseChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ correct_response: fieldValue });
  }; handlelearning_sourceChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ learning_source: fieldValue });
  }; chatbotlearningsourcefetchHandler = () => {
    fetch(configData.api_url + "C_Chatbotlearningsource/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ chatbotlearningsource: data.list });
        }
      });
  }; handleimprovement_suggestionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ improvement_suggestion: fieldValue });
  }; handleprocessed_for_trainingChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ processed_for_training: fieldValue });
  }; handleclaude_analysisChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ claude_analysis: fieldValue });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this chatbotlearning?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('chatbotlearning_Id', row.chatbotlearning_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Chatbotlearning/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.ChatbotlearningfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Chatbot Learning</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Chatbotlearning</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Conversation Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleconversation_idChange}>
                                        <option defaultValue> Select Conversation Id </option>
                                        {this.state.conversations.map((api, index, idx) => (
                                          <option key={index} value={api.conversations_Id}> {api.conversations_Id} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conversation_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>User Message</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleuser_messageChange} className="form-control" name="user_message" value={this.state.user_message} required="required" placeholder="Enter User Message" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_message} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Bot Response</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlebot_responseChange} className="form-control" name="bot_response" value={this.state.bot_response} required="required" placeholder="Enter Bot Response" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.bot_response} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>User Feedback</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleuser_feedbackChange}>
                                        <option defaultValue> Select User Feedback </option>
                                        {this.state.chatbotuserfeedback.map((api, index, idx) => (
                                          <option key={index} value={api.helpful}> {api.helpful} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_feedback} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Correct Response</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecorrect_responseChange} className="form-control" name="correct_response" value={this.state.correct_response} required="required" placeholder="Enter Correct Response" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.correct_response} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Learning Source</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlelearning_sourceChange}>
                                        <option defaultValue> Select Learning Source </option>
                                        {this.state.chatbotlearningsource.map((api, index, idx) => (
                                          <option key={index} value={api.user_feedback}> {api.user_feedback} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.learning_source} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Improvent Suggestion</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleimprovement_suggestionChange} className="form-control" name="improvement_suggestion" value={this.state.improvement_suggestion} required="required" placeholder="Enter Improvent Suggestion" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.improvement_suggestion} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Processed For Training</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleprocessed_for_trainingChange} className="form-control" name="processed_for_training" value={this.state.processed_for_training} required="required" placeholder="Enter Processed For Training" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_for_training} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Claude Analysis</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleclaude_analysisChange} className="form-control" name="claude_analysis" value={this.state.claude_analysis} required="required" placeholder="Enter Claude Analysis" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claude_analysis} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.ChatbotlearningsubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Chatbotlearning</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Conversation Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleconversation_idChange}>
                                          <option defaultValue> Select Conversation Id </option>
                                          {this.state.conversations.map((api, index, idx) => (
                                            <option key={index} value={api.conversations_Id}> {api.conversations_Id} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.conversation_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>User Message</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleuser_messageChange} className="form-control" name="user_message" value={this.state.user_message} required="required" placeholder="Enter User Message" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_message} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Bot Response</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlebot_responseChange} className="form-control" name="bot_response" value={this.state.bot_response} required="required" placeholder="Enter Bot Response" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.bot_response} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>User Feedback</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleuser_feedbackChange}>
                                          <option defaultValue> Select User Feedback </option>
                                          {this.state.chatbotuserfeedback.map((api, index, idx) => (
                                            <option key={index} value={api.helpful}> {api.helpful} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.user_feedback} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Correct Response</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecorrect_responseChange} className="form-control" name="correct_response" value={this.state.correct_response} required="required" placeholder="Enter Correct Response" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.correct_response} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Learning Source</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlelearning_sourceChange}>
                                          <option defaultValue> Select Learning Source </option>
                                          {this.state.chatbotlearningsource.map((api, index, idx) => (
                                            <option key={index} value={api.user_feedback}> {api.user_feedback} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.learning_source} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Improvent Suggestion</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleimprovement_suggestionChange} className="form-control" name="improvement_suggestion" value={this.state.improvement_suggestion} required="required" placeholder="Enter Improvent Suggestion" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.improvement_suggestion} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Processed For Training</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleprocessed_for_trainingChange} className="form-control" name="processed_for_training" value={this.state.processed_for_training} required="required" placeholder="Enter Processed For Training" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processed_for_training} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Claude Analysis</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleclaude_analysisChange} className="form-control" name="claude_analysis" value={this.state.claude_analysis} required="required" placeholder="Enter Claude Analysis" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.claude_analysis} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.ChatbotlearningupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}